import React, { createContext } from 'react';

const LaunchContext = createContext({});
const CreditsContext = createContext({});
const StripeContext = createContext({});

export { LaunchContext, StripeContext, CreditsContext };
